import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = "https://admin.chatindiacom.cloud/api";

function AgencyList() {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [updatingId, setUpdatingId] = useState(null);

  const getToken = () => localStorage.getItem("authToken");

  const api = axios.create({
    baseURL: BASE_URL,
    headers: { Authorization: `Bearer ${getToken()}` },
  });

  const fetchAgencies = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/agencies/list", {
        params: search ? { search } : {},
      });
      setAgencies(res.data.agencies || []);
    } catch (err) {
      toast.error("Failed to load agencies");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAgencies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggleStatus = async (agency) => {
    const newStatus = agency.status === 1 ? 0 : 1;
    setUpdatingId(agency.id);
    try {
      await api.post("/admin/agencies/update-status", {
        id: agency.id,
        status: newStatus,
      });
      toast.success(
        newStatus === 1 ? "Agency approved" : "Agency disabled"
      );
      setAgencies((prev) =>
        prev.map((a) => (a.id === agency.id ? { ...a, status: newStatus } : a))
      );
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to update status");
    }
    setUpdatingId(null);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") fetchAgencies();
  };

  return (
    <div className="min-h-screen px-4 py-6 dark:bg-primary md:px-8 xl:ml-72">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold font-poppins text-[#000000] dark:text-darkText">
          Agency List
        </h2>
        <div className="flex gap-2">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={handleSearchKeyDown}
            placeholder="Search by name or code"
            className="border border-gray-400 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-gray-600 dark:bg-primary dark:text-darkText"
          />
          <button
            onClick={fetchAgencies}
            style={{ backgroundColor: "#6c5ce7" }}
            className="px-4 py-2 text-sm font-semibold text-white rounded-lg font-poppins shadow-sm hover:opacity-90"
          >
            Search
          </button>
        </div>
      </div>

      <div className="overflow-x-auto bg-white border border-[#F2F2F2] rounded-xl dark:bg-primary dark:border-[#1F1F1F]">
        <table className="w-full text-sm text-left font-poppins">
          <thead>
            <tr className="text-[#000000] dark:text-darkText border-b border-[#F2F2F2] dark:border-[#1F1F1F]">
              <th className="px-4 py-3">ID</th>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Code</th>
              <th className="px-4 py-3">Description</th>
              <th className="px-4 py-3">Owner</th>
              <th className="px-4 py-3">Commission %</th>
              <th className="px-4 py-3">Created At</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={8} className="py-6 text-center text-[#5B5B5B] dark:text-[#AAAAAA]">
                  Loading...
                </td>
              </tr>
            ) : agencies.length === 0 ? (
              <tr>
                <td colSpan={8} className="py-6 text-center text-[#5B5B5B] dark:text-[#AAAAAA]">
                  No agencies found.
                </td>
              </tr>
            ) : (
              agencies.map((agency) => (
                <tr
                  key={agency.id}
                  className="border-b border-[#F2F2F2] dark:border-[#1F1F1F] text-[#5B5B5B] dark:text-[#AAAAAA]"
                >
                  <td className="px-4 py-3">{agency.id}</td>
                  <td className="px-4 py-3">{agency.name}</td>
                  <td className="px-4 py-3">{agency.code}</td>
                  <td className="px-4 py-3">{agency.description || "—"}</td>
                  <td className="px-4 py-3">{agency.owner_name || "—"}</td>
                  <td className="px-4 py-3">{agency.commission_percent}</td>
                  <td className="px-4 py-3">{agency.created_at}</td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => handleToggleStatus(agency)}
                      disabled={updatingId === agency.id}
                      className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
                        agency.status === 1
                          ? "bg-green-100 text-green-700 hover:bg-green-200"
                          : "bg-red-100 text-red-700 hover:bg-red-200"
                      }`}
                    >
                      {updatingId === agency.id
                        ? "..."
                        : agency.status === 1
                        ? "Approved"
                        : "Disabled"}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AgencyList;